import React, { useState, useEffect, useRef } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import CustomerIdentity from "../../Images/Customer-identity-management.svg";
import cardData from "../../resources/cardData.json";
import logoTextData from "../../resources/logoTextData.json";
import imageHeader from "../../resources/imageHeader.json";
import access from "../../Images/access&identityImage.jpg";
import { ReactComponent as Lock } from "../../Images/shield-lock.svg";
import { ReactComponent as SeamlessUser } from "../../Images/person-video3.svg";
import { ReactComponent as Migration } from "../../Images/shuffle.svg";
import { ReactComponent as APIs } from "../../Images/database-gear.svg";
import { ReactComponent as SelfService } from "../../Images/person-gear.svg";
import { ReactComponent as Recycle } from "../../Images/recycle.svg";
import { ReactComponent as Analytics } from "../../Images/bar-chart-line.svg";
import { ReactComponent as Multichannel } from "../../Images/bezier2.svg";
import { ReactComponent as Scalability } from "../../Images/graph-up-arrow.svg";
import { ReactComponent as Fingerprint } from "../../Images/fingerprint.svg";
import { ReactComponent as Signup } from "feather-icons/dist/icons/log-in.svg";
import { ReactComponent as Sso } from "../../Images/file-earmark-lock.svg";
import { ReactComponent as Mfa } from "../../Images/building-lock.svg";
import DetailsCard from "../WhatWeDo/components/DetailsCard.js";
import SubHeadings from "../WhatWeDo/components/SubHeadings.js";
import ImageHeader from "../WhatWeDo/components/ImageHeader.js";
import SliderPage from "../WhatWeDo/components/SliderPage.js";
import IconCard from "../WhatWeDo/components/IconCard.js";
import CIAMLogoCard from "../WhatWeDo/components/CIAMLogoCard.js";
import { ContactUsPDF } from "./CommonPages/ContactUsPDF.js";
import WhoWeArePDF from "./CommonPages/WhoWeArePDF.js";
import Slider from "../WhatWeDo/components/Slider.js";
import TeckStackPDF from "./CommonPages/TeckStackPDF.js";

const ThreeColumnContainer = styled.div`
  ${tw`mt-1 flex flex-col items-center lg:items-stretch lg:flex-row  md:flex-row md:items-stretch md:justify-center sm:flex-wrap lg:justify-center max-w-screen-lg mx-auto`}
`;

const TwoCol = styled.div`
  ${tw`flex justify-center max-w-screen-xl mx-auto`}
`;

const Wrapper = tw.div`max-w-screen-xl mx-auto py-2  mb-10`;
const Description = tw.p`px-6 font-semibold py-2  text-xl text-gray-900 text-justify`;
const Card = styled.div`
  ${tw`flex items-center   text-center h-full lg:w-1/2  md:px-10 px-2 pb-5`}
  .imageContainer {
    ${tw` items-start mt-3 rounded-full text-red-500  flex-shrink-0`}
    .image {
      ${tw`w-10 h-10 `}
    }
  }

  .textContainer {
    ${tw`mt-4 ml-2`}
  }

  .textContainerr {
    ${tw`mt-2 ml-1`}
  }

  .title {
    ${tw`mt-4  text-blue-900 font-bold  pb-1  text-lg  h-5`}
  }

  .titlee {
    ${tw`mt-2  text-blue-900 font-semibold  pb-1  text-lg  h-3`}
  }

  .description {
    ${tw`mt-4 text-justify px-5  md:text-justify  sm:text-justify leading-relaxed`}
    font-size: 16px;
  }

  .descriptionn {
    ${tw`text-justify px-2  md:text-justify  sm:text-justify leading-relaxed`}
    font-size: 14px;
  }

  .link {
    ${tw`mt-auto inline-flex items-center  justify-end w-full text-sm font-bold text-blue-700 leading-none hocus:text-primary-900 transition duration-300`}
    .icon {
      ${tw`ml-2 w-4`}
    }
  }
`;
const WrapperDescription = tw.div`max-w-screen-xl mx-auto `;
const LogoContainer = tw.div`flex lg:justify-end absolute mb-10 z-1 w-full`;
const LogoText = tw.h5`ml-0 text-6xl pt-5 text-white font-bold `;

let data = [
  {
    imageSrc: <Lock />,
  },
  {
    imageSrc: <SeamlessUser />,
  },
  {
    imageSrc: <Migration />,
  },
  {
    imageSrc: <APIs />,
  },
  {
    imageSrc: <Multichannel />,
  },
  {
    imageSrc: <SelfService />,
  },
  {
    imageSrc: <Recycle />,
  },
  {
    imageSrc: <Analytics />,
  },
  {
    imageSrc: <Scalability />,
  },
];

const keyBenefits = cardData.customerIdentity.keyBenefits.map((item, index) => (
  <DetailsCard
    key={index}
    title={item.point}
    description={item.description}
    imageSrc={data[index].imageSrc}
  />
));

const CustomerIdentityManagementPDF = ({ title }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  let [current, setCurrent] = useState(0);

  let slidesData = [
    {
      image: access,
      typeID: "element3",
      typedHead:
        "CIAM streamlines customer authentication and authorization in apps, enhancing registration and login experiences.",
      heading1: "Customer identity  ",
      heading2: "& access management",
      route: "/what-we-do/customer-identity-and-access-management",
      routeState: "",
      buttonName: "Visit",
    },
  ];

  let slides = [<SliderPage slidesData={slidesData[0]} imagehalf={true} />];

  useEffect(() => {
    document.title =
      "Welcome to Iqura - Customer identity and access management";
    let descMeta = document.querySelector("meta[name='description']");
    descMeta.setAttribute(
      "content",
      "Iqura offers a comprehensive customer identity and access management (CIAM) solution. Harness the power of Auth0, Microsoft Identity, Okta, AWS Cognito, Active Directory, and Google integration for seamless and secure access control. Streamline authentication processes, enhance security, and deliver exceptional user experiences with our tailored CIAM solution."
    );
    let keyword = document.querySelector("meta[name='keywords']");
    keyword.setAttribute(
      "content",
      "CIAM, Customer Identity and Access Management, Auth0, Microsoft Identity, Okta, AWS Cognito, Active Directory, Google, Identity Management, Access Control, Authentication, User Experience, Security, Seamless Integration, Identity Solutions "
    );
    const link = document.createElement("link");
    link.rel = "canonical";
    link.href =
      "https://www.iqura.tech/what-we-do/customer-identity-and-access-management";
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, []);

  let cardData = [
    {
      heading: "Single Sign-On (SSO)",
      title: "Single Sign-On (SSO)",
      description:
        " - Single Sign-On (SSO) is a technology that allows users to access multiple applications or services with a single set of login credentials. Instead of managing separate usernames and passwords for each application, users can authenticate once and gain access to all authorized resources without the need for additional logins.",
    },
    {
      heading: "Two-Factor (2FA) and Multi-Factor Authentication (MFA)",
      title: "Two-Factor (2FA) and Multi-Factor Authentication (MFA)",
      description:
        " - Enhances security by requiring users to provide additional verification beyond just a password. Provides an extra layer of protection against unauthorized access, aligning with CIAM's goal to offer secure yet user-friendly authentication processes.",
    },
  ];
  const imgStyle = { width: "40px", height: "40px" };

  let ExpertiseData = [
    {
      imageSrc: <Signup style={imgStyle} />,
    },
    {
      imageSrc: <Fingerprint style={imgStyle} />,
    },
    {
      imageSrc: <Lock style={imgStyle} />,
    },
    {
      imageSrc: <Migration style={imgStyle} />,
    },
    {
      imageSrc: <Sso style={imgStyle} />,
    },
    {
      imageSrc: <Mfa style={imgStyle} />,
    },
  ];

  const ourExpertise = logoTextData.ourservices.ourexpertize.map(
    (item, index) => (
      <IconCard
        key={index}
        title={item.title}
        description={item.description}
        imageSrc={ExpertiseData[index]?.imageSrc}
      />
    )
  );

  return (
    <>
      <div className="overflow-hidden relative ">
        <div
          style={{ visibility: "hidden", position: "absolute", top: "-9999px" }}
        >
          <Slider />
        </div>
        <div></div>
        <div className="" style={{ height: "100vh" }}>
          <div className="overflow-hidden relative  ">
            <LogoContainer>
              <div className="flex lg:justify-end w-full mr-16  ">
                <LogoText className="logoFontFamily">Iqura</LogoText>
              </div>
            </LogoContainer>
            <div
              className="flex transition-transform ease-out duration-300 "
              style={{
                transform: `translateX(-${current * 100}%)`,
              }}
            >
              {slides.map((s) => {
                return (
                  <div className="z-22" style={{ width: "100%" }}>
                    {s}
                  </div>
                );
              })}
            </div>

            <div className="absolute bottom-0 py-4 flex justify-center gap-3 w-full   ">
              {slides.map((s, i) => {
                return (
                  <div
                    onClick={() => {
                      setCurrent(i);
                    }}
                  ></div>
                );
              })}
            </div>
          </div>

          <TwoCol>
            <WrapperDescription>
              <Description
                style={{
                  backgroundColor: "white",
                  marginTop: `${window.innerWidth <= 425 ? -140 : -35}px`,
                  padding: "40px",
                  transform: "scale(1.25)",
                }}
              >
                <ImageHeader
                  imageHeaderData={imageHeader.customerIdentity}
                  imgsource={CustomerIdentity}
                />
              </Description>
            </WrapperDescription>
          </TwoCol>
        </div>
        <WhoWeArePDF />
        <div
          className=" px-20 pt-20 flex justify-center items-center  "
          style={{ height: "100vh" }}
        >
          <div className="px-20 pb-32" style={{ transform: "scale(1.2)" }}>
            <Wrapper>
              <SubHeadings heading2="Overview" />
            </Wrapper>

            <ThreeColumnContainer>{ourExpertise}</ThreeColumnContainer>
            <Wrapper>
              <div>
                <SubHeadings
                  heading1="Key Components of Customer identity and access management"
                  heading2=""
                />
                <div className="flex flex-col md:flex-row ">
                  {cardData.map((item, index) => {
                    return (
                      <Card key={index}>
                        <span className="textContainer">
                          <p className="description">
                            <span className="title">{item.title}</span>
                            {item.description}
                          </p>
                        </span>
                      </Card>
                    );
                  })}
                </div>
              </div>
            </Wrapper>
          </div>
        </div>

        <div
          className=" flex justify-center items-center  "
          style={{ height: "100vh" }}
        >
          <div className="px-20 pb-50" style={{ transform: "scale(1.35)" }}>
            <Wrapper>
              <SubHeadings heading1="Key" heading2="benefits" />
            </Wrapper>
            <ThreeColumnContainer>{keyBenefits}</ThreeColumnContainer>
          </div>
        </div>
        <div
          className="px-20 "
          style={{ height: "100vh", paddingTop: "250px" }}
        >
          <div
            id="ourservices"
            className="div-class"
            style={{ transform: "scale(1.2)" }}
          >
            <Wrapper>
              <SubHeadings heading1="Our" heading2="Services" />
            </Wrapper>
            <div className="pt-20">
              <CIAMLogoCard />
            </div>
          </div>
        </div>
        <TeckStackPDF/>
        <ContactUsPDF />
      </div>
    </>
  );
};

export default CustomerIdentityManagementPDF;
